const percentage = "percentage";

export const SUMMARY_COLUMNS = Object.freeze([
  {label: "月份", key: "month", width: 10},
  {label: "时间", key: "period", width: 12},
  {label: "日更", key: "daily_count", width: 8},
  {label: "ai图占比", key: "ai_ratio", format: percentage, width: 12},
  {label: "展示u", key: "impression_u_avg", width: 12},
  {label: "进入数u", key: "enter_u_avg", width: 12},
  {label: "进入率u", key: "enter_rate_u", format: percentage, width: 12},
  {label: "ai图进入率u", key: "ai_enter_rate_u", format: percentage, width: 14},
  {label: "完成率u", key: "finish_rate_u", format: percentage, width: 12},
  {label: "ai图完成率u", key: "ai_finish_rate_u", format: percentage, width: 14},
  {label: "盲盒进入数u", key: "daily_enter_u_avg", width: 14},
  {label: "A类进入率u", key: "a_enter_rate_u", format: percentage, width: 12},
  {label: "8%以上", key: "a_rate_ge_8", width: 12},
  {label: "6%~8%", key: "a_rate_6_to_8", width: 12},
  {label: "6%以下", key: "a_rate_lt_6", width: 12},
  {label: "B类进入率u", key: "b_enter_rate_u", format: percentage, width: 12},
  {label: "7.0%以上", key: "b_rate_ge_7", width: 14},
  {label: "5%~7%", key: "b_rate_5_to_7", width: 12},
  {label: "5%以下", key: "b_rate_lt_5", width: 12},
]);

export function buildSummaryRows(summary) {
  return [SUMMARY_COLUMNS.map(column => summary[column.key])];
}

export function getSummaryPercentageCells(rowNumber) {
  return SUMMARY_COLUMNS
    .map((column, index) => column.format === percentage ? `${columnLetter(index)}${rowNumber}` : null)
    .filter(Boolean);
}

function columnLetter(index) {
  let result = "";
  let value = index + 1;
  while (value > 0) {
    const remainder = (value - 1) % 26;
    result = String.fromCharCode(65 + remainder) + result;
    value = Math.floor((value - 1) / 26);
  }
  return result;
}
